import moment from "moment";

export function resolveAhpra(profile) {
  if (!profile) {
    return { number: null, date: null };
  }

  let number = null;
  let date = null;

  if (profile.ahpra && typeof profile.ahpra === "object" && !Array.isArray(profile.ahpra)) {
    number = profile.ahpra.number || null;
    date = profile.ahpra.date || null;
  } else if (typeof profile.ahpra === "string" && profile.ahpra) {
    number = profile.ahpra;
  }

  number =
    number ||
    profile.settings?.ahpra ||
    profile.details?.ahpra ||
    null;

  date =
    date ||
    profile.ahpraExpDate ||
    profile.ahpraExpiry ||
    profile.settings?.ahpraExpDate ||
    profile.details?.ahpraExpDate ||
    null;

  return { number, date };
}

export function formatAhpraDate(date) {
  if (!date) {
    return null;
  }

  const parsed = moment(date, ["YYYY-MM-DD", "DD/MM/YYYY", "DD MMM YYYY"], true);
  if (parsed.isValid()) {
    return parsed.format("DD MMM YYYY");
  }

  const fallback = moment(date);
  return fallback.isValid() ? fallback.format("DD MMM YYYY") : String(date);
}

export function formatAhpraDisplay(profile) {
  const { number, date } = resolveAhpra(profile);
  if (!number && !date) {
    return "";
  }

  const formattedDate = formatAhpraDate(date);
  const label = `AHPRA: ${number || "N/A"}`;
  return formattedDate ? `${label} (${formattedDate})` : label;
}
